import type { AnyAction } from 'redux';

import { isDev } from 'ts/constants/page-links';
import { EReduxTypes } from 'ts/enums/redux.types';
import type { IBaseAnalyticEvent, IReduxAction } from 'ts/interfaces/redux/redux.action';

export const sendAnalyticEvent = (event: IBaseAnalyticEvent): AnyAction => {
  const action: IReduxAction = {
    type: EReduxTypes.SEND_ANALYTIC_EVENT,
    analyticEvent: { ...event, data: { domain: getDomain(), is_transactional_user: true, ...event.data } }
  };
  return action;
};

function getDomain(): string {
  if (isDev) {
    return 'ltdcfqn.pdfguru.com/app/tools';
  } else {
    return 'pdfguru.com/app/tools';
  }
}
